import { APP_LINK, APP_ONE_LINK, DEEP_LINK } from '../enum/Constants';
import { firebaseInit } from './firebase';
import { isIOS, openDialog } from './utils';
import '../../public/static/css/reset.css';
import '../../public/static/css/base.css';
import '../../public/static/css/common.css';
import '../../public/static/css/etc.css';
var goToWeb = function () {
    window.location.href = '/';
};
var goAppLink = function () {
    if (isIOS()) {
        openDialog('iOS 앱은 준비중입니다.', goToWeb);
    }
    else if (window.location.search.includes('pid=gdn')) {
        var GDN_LINK = "".concat(APP_ONE_LINK, "?pid=gdn&c=bataa_pa_gdn_skt&is_retargeting=true") +
            "&af_ios_url=".concat(APP_LINK, "&af_android_url=").concat(DEEP_LINK, "/app");
        window.open(GDN_LINK, '_self');
    }
    else {
        window.open("".concat(DEEP_LINK, "/app"), '_self');
    }
};
var initialize = function () {
    firebaseInit();
    var btn = document.getElementById('download-btn');
    if (btn) {
        btn.addEventListener('click', goAppLink);
    }
};
initialize();
